<template>
    <div v-if="state.loading" style="text-align: center;">
        <img src="../assets/img/ajldr.gif" style="width: 100px"/>
    </div>
    <div v-else style="padding: 0 20px;">
        <PageHeader :page="page" :template="2" />
        <FullCalendar
            :events="calendarEvents"
            @event-click="handleEventClick"
        />
    </div>

    <ModalView
        :isVisible="state.ViewModal"
        :fixclose="true"
        @close="state.ViewModal = false">
        
        <FormView :columns="1"
            :fields="viewFields" :errors="state.errors"
            :loading="state.modalLoading" />
    </ModalView> 
    
</template>
<script>
import { defineComponent, ref,onMounted, reactive, computed} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import FullCalendar from '@/components/FullCalendar.vue';
import { useRoute, useRouter } from 'vue-router';
import ModalView from '@/components/ModalView.vue';
import FormView from '@/components/FormView.vue';

export default defineComponent({
name: 'CalendarView',
components: {FullCalendar,PageHeader,ModalView,FormView },
setup(){
    const state=reactive({loading:true, modalLoading:false,ViewModal:false})
    const route = useRoute();
    const router = useRouter();
    const staff = computed(() => route.params.id)
    const type = computed(() => route.params.type)
    const calendarEvents = ref([])
    const page=reactive({title:"Calendar", btn:"",
    desc:""})
    const viewFields=ref([]);
    var data={};
    if(type.value == "staff"){
      data={getStaffSchedule:staff.value};
    }else if(type.value == "project"){
      data={getProjectSchedule:staff.value};
    }
    onMounted(() => {
      call({
        url:urls.schedule,
        data:data,
        success:(res)=>{
          state.loading=false
          if(res.status){
            var d=res.msg;
            calendarEvents.value=[];
            Object.keys(d.cal).forEach(k => {
                calendarEvents.value.push(d.cal[k])
                page.title=d.title;
                page.desc=d.desc;
            })
          }else{
            alert(res.msg);
          }
        }
      })
    });

    function setErrors(res){
        var errors=[];
        Object.keys(res.msg).forEach(key => {
        var e=res.msg[key],er="";
        Object.keys(e).forEach(k => {
            er+=er=="" ? e[k] : ", "+e[k]
        })
        errors.push(er);
        });
        state.errors=errors;
    }

    function handleEventClick(event){
      if(event.id == "tasks"){
        router.push({ name: 'tasksview', params: { project: "s"+staff.value } });
        return;
      }
      state.ViewModal=true;
      state.modalLoading=true;
      if(type.value == "project"){
        call({
          url:urls.task,
          data:{viewTask:event.id},
          success:(res)=>{
            state.modalLoading=false;
            if(res.status){
              viewFields.value.length=0;
              var d=res.msg;
              viewFields.value.push(
                  { name: "Task Details", number: "1",data: 
                      [
                        {label: 'Project',name: 'project',
                        value: d.project},
                        { label: 'Name', name: 'name',
                        value: d.name  },
                        {  label: 'Deadline',name: 'deadline',
                        value: d.deadline},
                        {label: 'Description',name: 'desc',
                        value: d.description},
                        {label: 'Assignees',name: 'assignees',
                        value: d.assignees}
                      ]
                  }
              );
            }else{
              setErrors(res)
            }
          }
        })
      }else if(type.value == "staff"){
        call({
          url:urls.schedule,
          data:{getSchedule:event.id},
          success:(res)=>{
            state.modalLoading=false;
            if(res.status){
              viewFields.value.length=0;
              var d=res.msg.data;
              viewFields.value=[
                { name: "Schedule Details", number: "1",data: 
                  [{ name: 'title', label: 'Title',
                    value: d.title  },
                    { name: 'desc', label: 'Description',
                    value: d.desc },
                    {name:"type", label:"Type", value:d.type},
                    { name: 'start', label: 'Date',
                    value: d.sdate+"<br/>"+d.edate  },
                    {name:"privacy", label:"Visibility",
                      value:d.privacy
                    },
                    {name:"assignees", label:"Assigned to",
                      value:d.ass_n
                    }
                  ]
                }
              ]
            }else{
              setErrors(res)
            }
          }
        })
      }
    }
    return {state,calendarEvents,page, handleEventClick, viewFields}
}
})

</script>